export enum CustomPages {
    DELIVER_RETURNS = 'delivery-returns',
    PRIVACY_STATEMENT = 'privacy-statement',
    TERMS = 'terms-conditions',
    ABOUT = 'about-us'
}
